export default __webpack_public_path__ + "static/internalesgmb-f42bc008d03b04c58e757bf7392f0835.jpg";